module.exports = __webpack_public_path__ + "img/logo.0b30860b.png";